import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              color: "#1A1C19",
              border: "1px solid #E2E0D9",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
